// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"112":"fc60f784","171":"2e6f3038","200":"1e829a4b","376":"b0648eb1","377":"a19a063e","518":"af603923","671":"608aebb7","685":"59b4669d","738":"2fdbbb42","758":"bd0c0285","840":"deb6af6b","841":"2cf639dc","946":"f6970d29"}[chunkId] + ".js";
};